import React from 'react';
import styled from "styled-components";
import HayaatInvestmentForm from "./investment_form";
import {formatPhoneNumber} from "../../../../helpers/numbers";

const HayaatInvestmentFormSection = () => {
    return (
        <Container>
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-12 col-lg-6">
                        <h3 className="h1-bold">تعداد محدودی از این واحدها برای واگذاری باقی مانده‌اند!</h3>

                        <div className="mt-16">
                            <Content>
                                برای کسب اطلاعات بیشتر با شماره
                                <a href="tel:09150303080" className="h1-bold"> {formatPhoneNumber('09150303080')} </a> <br className="d-none d-lg-inline-block"/>
                                تماس بگیرید یا با ثبت درخواست در کادر
                                <span className="d-inline-block d-lg-none">&nbsp;زیر،&nbsp;</span>
                                <span className="d-none d-lg-inline-block">&nbsp;روبه‌رو،&nbsp;</span>
                                منتظر تماس کارشناسان ما باشید.
                            </Content>
                        </div>
                    </div>

                    <div className="col-lg-2"/>

                    <div className="col-12 col-lg-4">
                        <FormSection className="px-24 py-48 bg-white mt-48 mt-lg-0">
                            <HayaatInvestmentForm/>
                        </FormSection>
                    </div>
                </div>
            </div>
        </Container>
    );
};

export default React.memo(HayaatInvestmentFormSection);

// styles

const Container = styled.div`
    padding: 112px 0;
    background-color: ${props => props.theme.yellow};
    
    @media (max-width: ${props => props.theme.screenSmMax}) {
        padding: 64px 0 0;
    }
    
`;

const Content = styled.p`
    font-size: 24px;
    font-weight: 300;
    
    @media (max-width: ${props => props.theme.screenSmMax}) {
        font-size: 15px;
        
        .h1-bold {
            font-size: 16px !important;
        }
    }
    
`;

const FormSection = styled.div`
    border-radius: 16px;
    
    @media (max-width: ${props => props.theme.screenSmMax}) {
        border-radius: 16px 16px 0 0;
    }
`;